<div class="rez-code-editor" #editor>
</div>